import { BrowserRouter, Route, Routes } from "react-router-dom";
import Form from "./pages/Form";
import SlotPage from "./pages/SlotPage";
import BookingDetails from "./pages/BookingDetails";
import RequestSlot from "./pages/RequestSlotPage";
import RequestBookingDetails from "./pages/RequestBookingDetails";
import EmptySlots from "./pages/EmptySlots";
import AppointmentConfirmation from "./pages/AppointmentConfirmation";
import TherapistSlot from "./pages/therapistSlot";
import TherapistPage from "./pages/therapistPage";
import PackageForm from "./pages/PackageForm";
import PackagePurchaseFlow from "./pages/PackagePurchaseFlow";
import MetaForm from "./pages/metaForm";
import EmbadedForm from "./pages/EmbedadForm";
import mixpanel from 'mixpanel-browser';
import RouteTracker from "./RouteTracker";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SlotPageFreelancer from "./pages/SlotPageFreelancer";
import FreelanceBookingDetails from "./pages/FreelanceBookingDetails";
import OpsHoldForm from "./pages/OpsHoldForm";
import OpsHoldSlotPage from "./pages/OpsHoldSlotPage";
import OpsHoldSummaryPage from "./pages/OpsHoldSummaryPage";
import CompleteHoldBookingPage from "./pages/CompleteHoldBookingPage";
import HoldBookingConfirmation from "./pages/HoldBookingConfirmation";

import WixBridge from "./pages/WixBridge";

// import WixBridge from "./pages/WixBridge";
import PhysicaIntakeForm from "./pages/PhysicaIntakeForm";
import FullIntakeForm from "./pages/FullIntakeForm";

// ✅ NEW import
import PartnerRouter from "./routes/PartnerRouter";
import { PartnerProvider } from "./context/PartnerContext";

const PartnerWrapped = ({ children }) => (
  <PartnerProvider>{children}</PartnerProvider>
);

mixpanel.init("af4fa557ae3efe213a6374391a212ef6", {
  debug: true
});

function App() {
  return (
    <BrowserRouter>
      <RouteTracker />

      <Routes>
        {/* ✅ Existing main routes */}
        <Route path="/" element={<Form />} />
        <Route path="/freelancing-physio" element={<Form isFreelanceFlow={true} />} />
        <Route path="/:therapistId" element={<Form />} />
        <Route path="/metaForm" element={<MetaForm />} />
        <Route path="/embadedForm" element={<EmbadedForm />} />
        <Route path="/booking-slot" element={<SlotPage />} />
        <Route path="/booking-detail" element={<BookingDetails />} />
        <Route path="/request-slot" element={<RequestSlot />} />
        <Route path="/request-booking-detail" element={<RequestBookingDetails />} />
        <Route path="/empty-slot" element={<EmptySlots />} />
        <Route path="/appointment-confirmation" element={<AppointmentConfirmation />} />
        <Route path="/therapist-slot/:therapistId" element={<TherapistSlot />} />
        <Route path="/therapistPage" element={<TherapistPage />} />
        <Route path="/internal-package" element={<PackageForm />} />
        <Route path="/package-booking" element={<PackagePurchaseFlow />} />
        <Route path="/package-booking/:flowStep" element={<PackagePurchaseFlow />} />
        <Route path="/slot-page-freelancer" element={<SlotPageFreelancer />} />
        <Route path="/freelance-booking-detail" element={<FreelanceBookingDetails />} />
        <Route
          path="/ops/hold-booking"
          element={
            <PartnerWrapped>
              <OpsHoldForm />
            </PartnerWrapped>
          }
        />
        <Route
          path="/ops/hold-booking/slots"
          element={
            <PartnerWrapped>
              <OpsHoldSlotPage />
            </PartnerWrapped>
          }
        />
        <Route
          path="/ops/hold-booking/summary/:holdId"
          element={
            <PartnerWrapped>
              <OpsHoldSummaryPage />
            </PartnerWrapped>
          }
        />
        <Route
          path="/complete-booking/:secureToken"
          element={
            <PartnerWrapped>
              <CompleteHoldBookingPage />
            </PartnerWrapped>
          }
        />
        <Route
          path="/complete-booking/:secureToken/success"
          element={
            <PartnerWrapped>
              <HoldBookingConfirmation />
            </PartnerWrapped>
          }
        />

        <Route path="/wix-bridge" element={<WixBridge />} />


        <Route path="/intakeform" element={<PhysicaIntakeForm />} />
        <Route path="/fullform" element={<FullIntakeForm />} />

        {/* 🟣 NEW: Dynamic Partner Booking Flow */}
        <Route
          path="/:partnerSlug/*"
          element={
            <PartnerProvider>
              <PartnerRouter />
            </PartnerProvider>
          }
        />

      </Routes>
    </BrowserRouter>
  );
}

export default App;

